import { render, staticRenderFns } from "./RecordTable.vue?vue&type=template&id=d4293ad6&scoped=true"
import script from "./RecordTable.vue?vue&type=script&lang=js"
export * from "./RecordTable.vue?vue&type=script&lang=js"
import style0 from "./RecordTable.vue?vue&type=style&index=0&id=d4293ad6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4293ad6",
  null
  
)

export default component.exports